export { default } from './TimelineSeparator';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/TimelineSeparator/index.js
// module id = 900
// module chunks = 2